export const FETCH_USER_SESSIONCONTEXT_REQUEST = "FETCH_USER_SESSIONCONTEXT_REQUEST";
export const SAVE_ACTIVE_TOPHEADER_COMPONENT = "SAVE_ACTIVE_TOPHEADER_COMPONENT";
export const UPDATE_USER_THEME = "UPDATE_USER_THEME";
export const GET_USER_ORG_NAME_SUGGESTIONS = "GET_USER_ORG_NAME_SUGGESTIONS";
export const GET_USER_ORG_NAME_SUGGESTIONS_SUCCESS = "GET_USER_ORG_NAME_SUGGESTIONS_SUCCESS";
export const UPDATE_LAYOUT_SETTINGS = "UPDATE_LAYOUT_SETTINGS";
export const CHANGE_USER_ORG_TOKEN = "CHANGE_USER_ORG_TOKEN";
export const GET_LEFT_NAVIGATION = "GET_LEFT_NAVIGATION";
export const GET_LEFT_NAVIGATION_SUCCESS = "GET_LEFT_NAVIGATION_SUCCESS";
